import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrossSectionmodule = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3.5 1C3.77614 1 4 1.22386 4 1.5V5.5H20.5C20.7761 5.5 21 5.72386 21 6C21 6.27614 20.7761 6.5 20.5 6.5H4V13.5H12C12.2761 13.5 12.5 13.7239 12.5 14C12.5 14.2761 12.2761 14.5 12 14.5H4V22.5C4 22.7761 3.77614 23 3.5 23C3.22386 23 3 22.7761 3 22.5V1.5C3 1.22386 3.22386 1 3.5 1ZM15 17.5C15.2761 17.5 15.5 17.7239 15.5 18C15.5 18.2761 15.2761 18.5 15 18.5H9C8.72386 18.5 8.5 18.2761 8.5 18C8.5 17.7239 8.72386 17.5 9 17.5H15ZM20.5 9.5C20.7761 9.5 21 9.72386 21 10C21 10.2761 20.7761 10.5 20.5 10.5H10.5C10.2239 10.5 10 10.2761 10 10C10 9.72386 10.2239 9.5 10.5 9.5H20.5Z",
		fill: "#1B1E25"
	})]
});
const ForwardRef = forwardRef(SvgCrossSectionmodule);
export default ForwardRef;
